import { registerAction } from '../../Action'

const LOAD_DOWNLOADS = 'LOAD_DOWNLOADS'

const reducer = (state = {}, action) => {
  const downloads = action.payload.items || []

  const lastLoadedDownloadsPageSize = downloads.length

  return {
    ...state,
    downloads,
    lastLoadedPageSize: {
      ...state.lastLoadedPageSize,
      downloads: lastLoadedDownloadsPageSize,
    },
  }
}

const loadDownloads = registerAction(LOAD_DOWNLOADS, { reducer })

export default loadDownloads
